// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.0156 7.5L10 20.5166L8.69043 19.207L7.65723 20.2422H4L1.58594 17.8281L4.44824 14.9648L3.08594 13.6025L16.1006 0.585938L23.0156 7.5ZM4.41406 17.8281L4.82812 18.2422H6.82812L7.27637 17.793L5.86328 16.3799L4.41406 17.8281ZM14.457 5.05664L18.543 9.14258L20.1865 7.5L16.1006 3.41406L14.457 5.05664Z"}}]};

const PenFluorescenceFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen-fluorescence-filled',
    ref,
    icon: element,
  },
));

PenFluorescenceFilledIcon.displayName = 'PenFluorescenceFilledIcon';

export default PenFluorescenceFilledIcon;
